import classes from './InputLabel.module.scss';

const InputLabel = (props) => {
	return (
		<div className={classes.main}>
			<span>{props.text}</span>
		</div>
	);
};

export default InputLabel;
